export default __webpack_public_path__ + "static/media/first.9972cff1.mp4";